<template>
<div>
    <h1>Админка Строймастер</h1>
</div>
</template>

<script>
export default {
}

</script>

<style scoped>

</style>